"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccrualSettingsSchema = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const ROUNDING_METHOD_INVALID = "Please select a rounding method";
const UNKNOWN_FIELD = "Only roundingMethod can be set";
// Strict, because yup otherwise strips unknown keys silently rather than refusing them.
exports.AccrualSettingsSchema = yup
    .object({
    roundingMethod: yup
        .string()
        .required(ROUNDING_METHOD_INVALID)
        .oneOf(Object.values(mystake_common_sdk_1.RoundingMethod), ROUNDING_METHOD_INVALID)
        .label("Rounding method"),
})
    .noUnknown(true, UNKNOWN_FIELD)
    .strict();
//# sourceMappingURL=AccrualSettingsSchema.js.map